import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {UnitModel} from '../../../unit/unit.model';

@Injectable({
  providedIn: 'root'
})
export class AssignUnitToExecutorService {

  constructor(
    private http: HttpClient
  ) { }

  public assign(unitId: number, executorId: number, executorPricePlanGroupId: number) {
    return this.http.post<any>(
      environment.apiBasepoint + 'assign-unit-to-executor',
      {
        unitId: unitId,
        executorId: executorId,
        executorPricePlanGroupId: executorPricePlanGroupId,
      }
    );
  }
}
